import { render, staticRenderFns } from "./BookingDetailEmail.vue?vue&type=template&id=5bbd5e0e&"
import script from "./BookingDetailEmail.vue?vue&type=script&lang=js&"
export * from "./BookingDetailEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports